import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "about"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "This is an about page", -1);

const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
}